import { ProductResultActionsRenderTargetComponent } from './targets/product-result-actions.render-target.component';
import { ProductResultImagesRenderTargetComponent } from './targets/product-result-images.render-target.component';
import { ProductResultImportantInfoRenderTargetComponent } from './targets/product-result-important-info.render-target.component';
import { ProductResultImageOverlayRenderTargetComponent } from './targets/product-result-image-overlay.render-target.component';
import { ProductResultPriceRenderTargetComponent } from './targets/product-result-price.render-target.component';
import { ProductResultStockRenderTargetComponent } from './targets/product-result-stock.render-target.component';
import { ProductResultTitleRenderTargetComponent } from './targets/product-result-title.render-target.component';

export enum ProductResultRenderTarget {
  Title = 'title',
  Images = 'images',
  ImportantInfo = 'important-info',
  ImagesOverlay = 'images-overlay',
  Actions = 'actions',
  Price = 'price',
  Stock = 'stock',
}

export const ProductResultRenderTargetComponents = {
  [ProductResultRenderTarget.Title]: ProductResultTitleRenderTargetComponent,
  [ProductResultRenderTarget.Images]: ProductResultImagesRenderTargetComponent,
  [ProductResultRenderTarget.ImagesOverlay]: ProductResultImageOverlayRenderTargetComponent,
  [ProductResultRenderTarget.ImportantInfo]: ProductResultImportantInfoRenderTargetComponent,
  [ProductResultRenderTarget.Actions]: ProductResultActionsRenderTargetComponent,
  [ProductResultRenderTarget.Price]: ProductResultPriceRenderTargetComponent,
  [ProductResultRenderTarget.Stock]: ProductResultStockRenderTargetComponent,
} as const;
